import type { AdminUserContext, ApiResponse } from "@/types/auth";
import { apiFetch } from "./api-client";

/**
 * Fetches the currently-authenticated admin user's identity + permissions.
 * Backend endpoint: GET /system-user/context
 *
 * Returns null on failure — callers (e.g. route guards) treat null as
 * "auth flow needs to take over" rather than "permission denied".
 */
export const adminUserContextService = {
	async getCurrent(): Promise<AdminUserContext | null> {
		try {
			const response = await apiFetch<ApiResponse<AdminUserContext>>(
				"/system-user/context",
				{ method: "GET" },
			);

			if (!response?.result) {
				console.warn(
					"[adminUserContextService] Empty result from /system-user/context",
				);
				return null;
			}

			return response.result;
		} catch (err) {
			console.warn(
				"[adminUserContextService] Failed to fetch admin user context",
				err,
			);
			return null;
		}
	},
};
